/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import MicroModal from 'micromodal'

import './styles.scss'

class Addresses {
  constructor (element) {
    this.$el = $(element)

    // Setup Modal
    MicroModal.init()

    this.$el.on('click', '.address-toggle', (e) => {
      const formID = $(e.currentTarget).attr('aria-owns')
      this.modalOpen(formID)
    })
  }

  modalOpen (formID) {
    MicroModal.show(formID, {
      disableScroll: true
    })
  }
}

registerClass('Addresses', Addresses)
